import { useState, useEffect } from "react";
import { normalizeQnaList } from "../../channel/normalizePayload.js";
import { updateQnaItem, removeQnaItem, clearQnaChannel } from "../../hooks/adminStore.js";

export default function useQnaControls(session) {
  const [qna, setQna] = useState([]);

  useEffect(() => {
    if (!session) return;
    setQna(normalizeQnaList(session.qna) || []);
  }, [session]);

  function qnaToggle(id, isApproved) {
    const updated = qna.map((q) => (String(q.id) === String(id) ? { ...q, isApproved } : q));
    setQna(updated);
    if (!session) return;
    if (isApproved) {
      const question = updated.find((q) => String(q.id) === String(id));
      if (question) updateQnaItem(session.sessionId, question);
    } else {
      removeQnaItem(session.sessionId, id);
    }
  }

  function clearQnaChannelData() {
    if (!session) {
      console.warn("[clearQnaChannel] no session");
      return;
    }
    console.log(`[clearQnaChannel] clearing qna for session ${session.sessionId}`);
    clearQnaChannel(session.sessionId);
  }

  return { qna, qnaToggle, clearQnaChannel: clearQnaChannelData };
}
